module.exports = __webpack_public_path__ + "img/banner2.4a9a3191.png";